import classNames from "classnames";
import React from "react";

import { Animation, AnimationTarget, IAnimated } from "../Animations";
import { IPositionWrapperProps, PositionWrapper } from "../PositionWrapper";
import { IDropdownStateProps, withDropdownState } from "./withDropdownState";

export interface IDropdownProps extends IDropdownStateProps, Partial<IAnimated> {
  target: React.ReactNode;
  content: React.ReactNode;
  className?: string;
  disabled?: boolean;
  positionFixed?: boolean;
  placement?: IPositionWrapperProps["placement"];
  closeOnClickAnywhere?: boolean;
  modifiers?: IPositionWrapperProps["modifiers"];
  usePortal?: boolean;
}

export class DropdownComponent extends React.PureComponent<IDropdownProps> {
  static defaultProps: Partial<IDropdownProps> = {
    open: false,
  };

  renderTarget() {
    return React.cloneElement(this.props.target as React.ReactElement<any>, {
      onClick: this.props.onTargetClick,
    });
  }

  renderContent() {
    const { content: DropdownContent, animated = true, animation = "fade-slide" } = this.props;

    return (
      <AnimationTarget name={animation} disabled={!animated}>
        {DropdownContent}
      </AnimationTarget>
    );
  }

  render() {
    const { open, positionFixed, placement, wrapperRef, modifiers, usePortal } = this.props;
    const classes = classNames("el-dropdown", this.props.className);

    return (
      <span className={classes} ref={wrapperRef}>
        <Animation animate={!!open}>
          {visible => (
            <PositionWrapper
              placement={placement}
              targetComponent={this.renderTarget()}
              popperComponent={this.renderContent()}
              positionFixed={positionFixed}
              hidden={!visible}
              modifiers={modifiers}
              usePortal={usePortal}
            />
          )}
        </Animation>
      </span>
    );
  }
}

export const Dropdown = withDropdownState<IDropdownProps>(DropdownComponent);

export default Dropdown;
